var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "template-card-v2",
    {
      attrs: {
        "one-log": _vm.oneLog,
        linkedtype: _vm.linkedtype,
        linkedid: _vm.linkedid
      }
    },
    [
      _c(
        "template",
        { slot: "icon" },
        [
          _c("CompassObject", { attrs: { object: "marketing", size: "small" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "label" },
        [
          _vm.oneLog.hasOwnProperty("contacts")
            ? _c("person-list-light", {
                attrs: {
                  list: _vm.oneLog.contacts.params.list,
                  "placeholder-singular": "Collaborateur",
                  "placeholder-plural": "Collaborateurs"
                }
              })
            : _vm.oneLog.hasOwnProperty("thirds")
            ? _c("person-list-light", {
                attrs: {
                  list: _vm.oneLog.thirds.params.list,
                  "placeholder-singular": "Société",
                  "placeholder-plural": "Sociétés"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "div",
          {
            staticClass:
              "marketing-card__content-description typographies-paragraph-medium-regular"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getWording(_vm.oneLog.event, _vm.oneLog.eventDetails)
                ) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.canSeeDropdown
        ? _c(
            "div",
            { attrs: { slot: "aside" }, slot: "aside" },
            [
              _c(
                "el-dropdown",
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "action", size: "small" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _vm.canTogglePin
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: { disabled: !!_vm.intervalCallidES },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.togglePin(_vm.isPinned, {
                                    userForename: _vm.userForename,
                                    userName: _vm.userName
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.pinStatusLabel) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oneLog.canSee
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  return _vm.previewEvent(_vm.oneLog)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Voir")) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oneLog.can_edit
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  return _vm.editEvent(_vm.oneLog)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Modifier")) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oneLog.can_edit
                        ? _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  return _vm.deleteEvent(_vm.oneLog)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Supprimer")) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { slot: "linked" }, slot: "linked" }),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }